import { render, staticRenderFns } from "./CompareComponent.vue?vue&type=template&id=743dd264"
import script from "./CompareComponent.vue?vue&type=script&lang=js"
export * from "./CompareComponent.vue?vue&type=script&lang=js"
import style0 from "./CompareComponent.vue?vue&type=style&index=0&id=743dd264&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports